import { render, staticRenderFns } from "./AochenContent.vue?vue&type=template&id=39cb12a8&scoped=true"
import script from "./AochenContent.vue?vue&type=script&lang=js"
export * from "./AochenContent.vue?vue&type=script&lang=js"
import style0 from "./AochenContent.vue?vue&type=style&index=0&id=39cb12a8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39cb12a8",
  null
  
)

export default component.exports